<div class="modal-header" mat-dialog-title>
    <div class="modal-header-icon">
        <mat-icon class="material-symbols-outlined">remove_shopping_cart</mat-icon>
    </div>
    <div class="modal-header-titles">
        <h2 class="modal-title">Excluir estoque</h2>
        <span class="modal-subtitle">{{ data.rotuloDocumento }}</span>
    </div>
    <div class="modal-header-close-btn-container">
        <button mat-icon-button type="button" class="modal-close-btn" aria-label="Fechar" (click)="fechar()">
            <mat-icon class="material-symbols-outlined">close</mat-icon>
        </button>
    </div>
</div>

<mat-dialog-content class="modal-content scroll-suave">
    @if (isLoading) {
        <app-loading-box height="56" width="100%" marginTop="0"></app-loading-box>
        <app-loading-box height="56" width="100%" marginTop="12"></app-loading-box>
    } @else {
        @if (!movimentacoes.length) {
            <app-alert-card type="info" title="Nada a excluir">
                Não há estoque lançado para este pedido. Excluir estoque só atualiza o registro do pedido.
            </app-alert-card>
        } @else {
            <p class="pvxe-descricao">
                As movimentações de estoque deste pedido serão excluídas e o saldo volta aos locais de origem. Tudo ou
                nada: se algum saldo ficar negativo, nada é excluído.
            </p>

            @for (mov of movimentacoes; track mov.idEstoqueMovimentacao) {
                <div class="pvxe-linha">
                    <mat-icon class="material-symbols-outlined pvxe-icone">arrow_downward</mat-icon>
                    <div>
                        <strong>{{ mov.sequencia ? mov.sequencia + '. ' : '' }}{{ mov.descricao }}</strong>
                        @if (mov.descricaoProdutoFabricado) {
                            <span class="pvxe-detalhe">Componente de {{ mov.descricaoProdutoFabricado }}</span>
                        }
                        <span class="pvxe-detalhe">
                            +{{ mov.quantidade | abnt:'quantidade' }} de volta em "{{ mov.descricaoLocalizacao }}"
                        </span>
                        @if (mov.codigoLote) {
                            <span class="pvxe-detalhe">Lote: {{ mov.codigoLote }}</span>
                        }
                        @if (mov.codigoSerie) {
                            <span class="pvxe-detalhe">Série: {{ mov.codigoSerie }}</span>
                        }
                    </div>
                </div>
            }
        }

        <mat-form-field appearance="outline" class="w-100 pvxe-justificativa">
            <mat-label>Justificativa (opcional)</mat-label>
            <textarea matInput rows="2" [(ngModel)]="justificativa" maxlength="500" [disabled]="isExcluindo"></textarea>
            <mat-hint align="end">{{ justificativa.length }}/500</mat-hint>
        </mat-form-field>
    }
</mat-dialog-content>

<mat-dialog-actions class="modal-footer">
    <button mat-stroked-button type="button" class="btn-secondary" [disabled]="isExcluindo" (click)="fechar()">Cancelar</button>
    <button mat-flat-button type="button" class="btn-primary btn-spinner" [class.btn-loading]="isExcluindo"
        [disabled]="isLoading || isExcluindo" [attr.aria-label]="isExcluindo ? 'Excluindo estoque' : 'Excluir estoque'"
        (click)="confirmar()">
        <mat-icon class="material-symbols-outlined">delete</mat-icon>
        Excluir estoque
        @if (isExcluindo) { <mat-spinner diameter="20"></mat-spinner> }
    </button>
</mat-dialog-actions>
